import { createSelector, createSlice } from '@reduxjs/toolkit';
import { AppState } from '../../../redux/store';

export const shiftLifecycleSlice = createSlice({
  name: 'shiftLifecycleSlice',
  initialState: {
    isOpenAlertGeoLocationModal: false,
    isOpenGeolocationCompatibilityModal: false,
    isOpenEndChecklistModal: false,
  },
  reducers: {
    setIsOpenAlertGeoLocationModal: (state, action) => {
      state.isOpenAlertGeoLocationModal = action.payload;
    },
    setIsOpenGeolocationCompatibilityModal: (state, action) => {
      state.isOpenGeolocationCompatibilityModal = action.payload;
    },
    setIsOpenEndChecklistModal: (state, action) => {
      state.isOpenEndChecklistModal = action.payload;
    },
  },
});

export const {
  setIsOpenAlertGeoLocationModal,
  setIsOpenGeolocationCompatibilityModal,
  setIsOpenEndChecklistModal,
} = shiftLifecycleSlice.actions;

export const { reducer: shiftLifecycleReducer } = shiftLifecycleSlice;
const shiftLifecycleState = (state: AppState) => state.shiftLifecycleReducer;
export const getShiftLifecycleSlice = createSelector(shiftLifecycleState, (state) => state);
